<template>
	<div class="about">
		<div class="banner">
			<div class="in">
				<img class="title" src="@/assets/images/banner_about_text.png" />
				<div class="t">
					<div>未来，在集团的统一布局下，</div>
					<div>佰小轩矢志成为一个对各大产业有影响力的人才培训基地，</div>
					<div>通过持续微创新服务，改变在线成人教育培训生态，</div>
					<div>提升数以百万计学子的人生品质。</div>
				</div>
			</div>
			<img class="cover" src="@/assets/images/cover_about.png" />
		</div>

		<div class="main">
			<div class="top">
				<img src="@/assets/images/about_list_pic.png" />
				<div class="right">
					近年来，佰小轩业务增长稳定、品质优良、业绩屡创新高，
					已在<i>厦门、上海、杭州、苏州、南京、常州、合肥、深圳、广州、成都、太原、西安</i>等地成立多家分校，还将落地其他重点城市，以燎原之势辐射全国。
				</div>
			</div>
			
			<div class="time">
				<div class="item" v-for="(item, index) in time" :key="index">
					<div class="year">{{item.year}}</div>
					<div class="point"></div>
					<div class="info">
						<div class="title">{{item.title}}</div>
						<div class="des">{{item.des}}</div>
					</div>
				</div>
				<div class="line"></div>
			</div>
			
			<div class="list">
				<div class="item" v-for="(item, index) in list" :key="index">
					<div class="map-box">
						<!-- <baidu-map class="map" :center="item.position" :zoom="zoom" :scroll-wheel-zoom="false">
						    <bm-marker :position="item.position" :dragging="false"></bm-marker>
						</baidu-map> -->
						<img :src="item.pic"/>
					</div>
					<div class="info">
						<div class="title">
							<span class="t1">{{item.school}}</span>
							<span class="t2">{{item.phone}}</span>
							<span class="t3">{{item.name}}</span>
						</div>
						<div class="address">{{item.address}}</div>
					</div>
				</div>
			</div>
			
			<div class="tel">
				<div class="num">400-033-0086</div>
				<div class="tip">如需咨询，请拨打电话，小轩陪你一起进步！</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	// import BaiduMap from 'vue-baidu-map'
	
	// Vue.use(BaiduMap, {
	//     /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
	//     ak: 'piXQ5CgHFqEefqCVbhhBFfe6HjF7l4zW'
	// })
	export default {
		data() {
			return {
				zoom: 15,
				list: [{
						school: '苏州分校',
						phone: '13505196354',
						name: '王老师',
						address: '苏州市姑苏区干将东路178号苏州大学北校区 蓝园6栋209',
						pic:'苏州.png',
						position:{
							lng: 120.64522999999997,
							lat: 31.314020000000003
						},
					},
					{
						school: '南京分校',
						phone: '18261357055',
						name: '常老师',
						address: '南京市秦淮区长白街100号金陵科技学院秦淮硅巷大学科技园A栋4楼',
						pic:'南京.png',
						position:{
							lng: 118.89979800000003,
							lat: 31.903683000000008
						},
					},
					{
						school: '徐州分校',
						phone: '19955139206',
						name: '丁老师',
						address: '江苏省徐州市铜山新区北京北路1号楼104铺',
						pic:'徐州.png',
						position:{
							lng: 117.186421,
							lat: 34.18559100000001
						},
					},
					{
						school: '常州分校',
						phone: '18861245075',
						name: '查老师',
						address: '江苏省常州市武进区武宜中路188号新城吾悦大厦低区1903',
						pic:'常州.png',
						position:{
							lng: 119.94185300000004,
							lat: 31.727426999999988
						},
					},
					{
						school: '合肥分校',
						phone: '17615405211',
						name: '李老师',
						address: '合肥市蜀山区长江西路拓基金座C1622',
						pic:'合肥.png',
						position:{
							lng: 117.21270806702586,
							lat: 31.860843586035056
						},
					},
					{
						school: '巢湖分校',
						phone: '18256941399',
						name: '陈老师',
						address: '巢湖市汇豪大厦407',
						pic:'巢湖.png',
						position:{
							lng: 117.88318102169677,
							lat: 31.6001603365198
						},
					},
					{
						school: '芜湖分校',
						phone: '15339690257',
						name: '鲁老师',
						address: '芜湖市镜湖区绿地新都会 d座 2006室芜湖学习中心',
						pic:'芜湖.png',
						position:{
							lng: 118.404530,
							lat: 31.329861
						},
					},
					{
						school: '广州分校',
						phone: '18284440638',
						name: '洪老师',
						address: '广东省广州市天河区泰安北路1号昌旺科创板块孵化器1131室',
						pic:'广州.png',
						position:{
							lng: 113.388548,
							lat: 23.131612
						},
					},
					{
						school: '太原分校',
						phone: '15832233190',
						name: '北老师',
						address: '山西省太原市万柏林区华润大厦T5-11层1101南',
						pic:'太原.png',
						position:{
							lng: 112.529044,
							lat: 37.809711
						},
					},
					{
						school: '厦门本部',
						phone: '18284440638',
						name: '洪老师',
						address: '厦门市思明区海翼大厦A栋2202-2单元',
						pic:'厦门.png',
						position:{
							lng: 118.094530,
							lat: 24.463039
						},
					},
				],
				time:[
					{
						year:'2011年',
						title:'正式成立',
						des:'佰小轩教育团队正式成立，同年与南京东方文理学院、南京南洋文理学院签订生源战略合作协议。',
					},
					{
						year:'2012年',
						title:'江苏多分校搭建',
						des:'在苏州、常州、徐州、镇江等地区与多家教育机构达成长期合作战略协议，更好地为苏南、苏北等地区学生提供教学服务。',
					},
					{
						year:'2013年',
						title:'“互联网+”跨区域教学',
						des:'充分响应李克强总理提出的“互联网+”的发展理念，与武汉大学、武汉理工大学、中南财经政法大学等多家省外高校优秀师资建立跨区域的互联网平台教学。',
					},
					{
						year:'2014年',
						title:'高校合作',
						des:'为了更好地为大众化人群提供优质教学服务，与南京大学、南京财经大学、南京师范大学等多家高校达成合作共识，最大化丰富成人教育的专业资源。',
					},
					{
						year:'2016年',
						title:'武汉工程大学同力申硕站点授权',
						des:'与武汉工程大学达成研究生（同等学力申硕）合作协议，成为武汉工程大学江苏地区唯一一家教学中心，并授权挂牌。',
					},
					{
						year:'2019年',
						title:'成立南京宏卓教育培训中心',
						des:'成立南京宏卓教育培训中心，颁发了《中华人民共和国民办学校办学许可证》，业务范围涵盖中小学文化教育、艺术培训、成人继续教育及公务员等相关职业培训，从此校区走上集团运营的轨道。同年，授予“秦淮区关工委委员”殊荣，更好地为秦淮区关心下一代做出力所能及的贡献。',
					},
					{
						year:'2020年',
						title:'与国家开放大学保险学院签订战略协议',
						des:'与国家开放大学保险学院签订战略协议，成立保险学院江苏教学中心，为江苏省保险单位工作人员提供更权威和全面的教学服务。',
					},
					{
						year:'2021年',
						title:'成立中国共产党党支部委员会',
						des:'建党一百周年之际，在秦淮区教育局党委的关怀下，成立了中国共产党党支部委员会，在我党的带领和领导下，更好地服务学员，回馈社会。',
					},
					{
						year:'2022年',
						title:'成立南京康养职业培训学校',
						des:'成立南京康养职业培训学校，人社局颁发民办学许可证，培训项目涉及健康管理师、养老护理员，康复等，为社区老年服务机构及其康养医院输送了大量的康养复合型人才。同年与南京泰斯特考评中心合作，在市区设立考点，考培结合，举办证券、基金、银行从业人员、房地产经纪人等相关考试。',
					},
					{
						year:'2024年',
						title:'成立佰小轩教育集团',
						des:'成立佰小轩教育集团公司，在集团的引领和指导下，更好地打开全国市场，用专业的水平更好地为学员提供培训服务。',
					},
				]
			}
		},
		created() {

		},
		mounted() {

		},
		computed: {},
		watch: {},
		methods: {

		},
		beforeDestroy() {

		},
		components: {

		}
	}
</script>

<style scoped>
    /* 去掉地图左下角的百度LOGO */
    .map-box >>> .anchorBL {
        display:none
    }
</style>
<style scoped lang="less">
	.about {
		background: #EFF2FB;
		padding-bottom: 60px;
	}

	.banner {
		margin-bottom: 50px;
		height: 700px;
		background: url('../../assets/images/banner_about.png') center center no-repeat;
		background-size: cover;
		position: relative;
		z-index: 1;

		.cover {
			height: 88px;
			position: absolute;
			width: 100%;
			left: 0;
			right: 0;
			bottom: -4px;
			z-index: 1;
		}

		.in {
			width: 1240px;
			height: 700px;
			margin: 0 auto;
			display: flex;
			// align-items: center;
			justify-content: center;
			flex-direction: column;

			.title {
				width: 583px;
				height: auto;
				margin-bottom: 10px;
			}

			.t {
				font-size: 23px;
				padding-left: 5px;
				color: #fff;

				div {
					font-weight: 300;
				}

			}
		}
	}

	.main {
		width: 1240px;
		margin: 0 auto;
		box-shadow: rgba(0, 37, 84, 0.2) 0 6px 30px;
		background: #fff url('../../assets/images/list_bg.png') right bottom no-repeat;
		background-size: 620px auto;
		border-radius: 8px;
		min-height: 500px;
		position: relative;
		z-index: 2;
		
		.tel{
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding-bottom: 30px;
			.num{
				color: #1A7EFD;
				font-size: 49px;
				font-family: 'DIN';
				font-weight: bold;
				margin-bottom: 10px;
			}
			.tip{
				color: #95A9B1;
				font-size: 16px;
			}
		}

		.top {
			background: #F1F7FF;
			display: flex;
			border-radius: 0 8px 0 0;

			img {
				width: 382px;
				height: auto;
				margin-top: -127px;
			}

			.right {
				padding: 50px 160px 0 40px;
				font-size: 24px;
				font-weight: 500;

				i {
					color: #1A7EFD;
				}
			}
		}
		
		.time{
			padding: 30px 64px 0 64px;
			position: relative;
			.line{
				width: 1px;
				border-left: 1px dashed #BCCCE1;
				position: absolute;
				left: 176px;
				top: 50px;
				bottom: 80px;
				z-index: 1;
			}
			.item{
				display: flex;
				margin-bottom: 30px;
				.year{
					width: 84px;
					height: 33px;
					color: #fff;
					background: linear-gradient(to bottom, #10A3FE, #1E59FF);
					font-size: 19px;
					font-weight: 500;
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 12px 0 12px 0;
				}
				.point{
					position: relative;
					z-index: 6;
					width: 12px;
					height: 12px;
					border-radius: 50%;
					background: #1C65FF;
					border: #CDE3FF 3px solid;
					margin-top: 6px;
					margin-left: 20px;
					margin-right: 20px;
				}
				.info{
					flex: 1;
					.title{
						color: #1A7EFD;
						font-size: 22px;
						font-weight: 500;
						margin-bottom: 4px;
					}
					.des{
						color: #24242A;
						font-size: 20px;
					}
				}
			}
		}

		.list {
			padding: 30px 0;

			.item {
				display: flex;
				align-items: center;
				padding: 10px 64px;

				.map-box {
					background: #F6F8FB;
					width: 300px;
					height: 158px;
					margin-right: 48px;
					.map{
						width: 100%;
						height: 100%;
					}
					img{
						width: 100%;
						height: 100%;
					}
				}

				.info {
					flex: 1;

					.title {
						display: flex;
						align-items: center;
						margin-bottom: 10px;

						.t1 {
							font-weight: 500;
							font-size: 26px;
							color: #3B4664;
							margin-right: 30px;
						}

						.t2 {
							font-weight: 500;
							font-size: 24px;
							color: #1A7EFD;
							margin-right: 20px;
						}

						.t3 {
							font-size: 20px;
							color: #AEB3C0;
						}
					}

					.address {
						color: #AEB3C0;
						font-size: 20px;
					}
				}
			}
		}
	}
</style>
